/* eslint-disable react/prop-types, no-unused-vars */

import { Form, Input } from 'antd';

const CalculateFieldForm = ({ config, columns, onChange }) => (
    <Form layout="vertical" initialValues={config} onValuesChange={(_, values) => onChange(values)}>
        <Form.Item label="New Column Name" name="newColumnName" rules={[{ required: true }]}>
            <Input placeholder="e.g., total_amount" />
        </Form.Item>
        <Form.Item
            label="Formula"
            name="formula"
            rules={[{ required: true }]}
            help="Use [column_name] to reference columns"
        >
            <Input.TextArea placeholder="e.g., [price] * [quantity]" rows={3} />
        </Form.Item>
    </Form>
);

export default CalculateFieldForm;
